import createIcon from '@/lib/create-icon'

const MotorbikesIcon = createIcon(
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='18'
    height='18'
    viewBox='0 0 46 46'
    fill='none'
  >
    <path
      fill='none'
      d='M37.3749 36.4168C40.0213 36.4168 42.1666 34.2715 42.1666 31.6252C42.1666 28.9788 40.0213 26.8335 37.3749 26.8335C34.7286 26.8335 32.5833 28.9788 32.5833 31.6252C32.5833 34.2715 34.7286 36.4168 37.3749 36.4168Z'
      stroke='url(#paint0_linear_5307_2546)'
      strokeWidth='2.875'
    />
    <path
      fill='none'
      d='M37.3749 36.4168C40.0213 36.4168 42.1666 34.2715 42.1666 31.6252C42.1666 28.9788 40.0213 26.8335 37.3749 26.8335C34.7286 26.8335 32.5833 28.9788 32.5833 31.6252C32.5833 34.2715 34.7286 36.4168 37.3749 36.4168Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
    />
    <path
      fill='none'
      d='M37.3749 36.4168C40.0213 36.4168 42.1666 34.2715 42.1666 31.6252C42.1666 28.9788 40.0213 26.8335 37.3749 26.8335C34.7286 26.8335 32.5833 28.9788 32.5833 31.6252C32.5833 34.2715 34.7286 36.4168 37.3749 36.4168Z'
      stroke='url(#paint1_radial_5307_2546)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
    />
    <path
      fill='none'
      d='M8.62492 36.4168C11.2713 36.4168 13.4166 34.2715 13.4166 31.6252C13.4166 28.9788 11.2713 26.8335 8.62492 26.8335C5.97855 26.8335 3.83325 28.9788 3.83325 31.6252C3.83325 34.2715 5.97855 36.4168 8.62492 36.4168Z'
      stroke='url(#paint2_linear_5307_2546)'
      strokeWidth='2.875'
    />
    <path
      fill='none'
      d='M8.62492 36.4168C11.2713 36.4168 13.4166 34.2715 13.4166 31.6252C13.4166 28.9788 11.2713 26.8335 8.62492 26.8335C5.97855 26.8335 3.83325 28.9788 3.83325 31.6252C3.83325 34.2715 5.97855 36.4168 8.62492 36.4168Z'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
    />
    <path
      fill='none'
      d='M8.62492 36.4168C11.2713 36.4168 13.4166 34.2715 13.4166 31.6252C13.4166 28.9788 11.2713 26.8335 8.62492 26.8335C5.97855 26.8335 3.83325 28.9788 3.83325 31.6252C3.83325 34.2715 5.97855 36.4168 8.62492 36.4168Z'
      stroke='url(#paint3_radial_5307_2546)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
    />
    <path
      fill='none'
      d='M38.7833 15.0835C41.2395 18.0724 42.0928 20.9143 42.1654 22.4169C40.8813 21.8297 39.4394 21.5002 37.9156 21.5002C33.229 21.5002 29.0219 24.6165 28.0172 28.7678C27.777 29.7602 27.657 30.2565 27.3962 30.4616C27.1355 30.6668 26.7148 30.6668 25.8738 30.6668H20.3561C19.5085 30.6668 19.0848 30.6668 18.823 30.4589C18.5612 30.2507 18.4465 29.7562 18.2172 28.767C17.267 24.6692 13.4103 21.1073 9.39537 21.4089C8.9908 21.4394 8.78851 21.4546 8.64973 21.4237C8.51096 21.3927 8.37123 21.3139 8.0918 21.1559C7.28512 20.7004 6.46026 20.2678 5.66929 19.7853C4.56732 19.1131 3.87763 17.9315 3.83427 16.6414C3.80961 15.9072 4.23187 15.1776 5.08486 15.3783L17.3912 18.2743C18.3156 18.4919 18.7778 18.6007 19.175 18.5266C19.5722 18.4526 20.059 18.1196 21.0328 17.4536C23.5021 15.7651 27.4153 14.1702 31.3163 15.5793C32.3841 15.965 32.9181 16.1579 33.2223 16.1675C33.5264 16.1771 33.9723 16.0474 34.8639 15.7879C36.3075 15.3677 37.6665 15.1497 38.7833 15.0835ZM38.7833 15.0835C37.2438 13.21 35.0743 11.2788 32.0727 9.5835'
      stroke='url(#paint4_linear_5307_2546)'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M38.7833 15.0835C41.2395 18.0724 42.0928 20.9143 42.1654 22.4169C40.8813 21.8297 39.4394 21.5002 37.9156 21.5002C33.229 21.5002 29.0219 24.6165 28.0172 28.7678C27.777 29.7602 27.657 30.2565 27.3962 30.4616C27.1355 30.6668 26.7148 30.6668 25.8738 30.6668H20.3561C19.5085 30.6668 19.0848 30.6668 18.823 30.4589C18.5612 30.2507 18.4465 29.7562 18.2172 28.767C17.267 24.6692 13.4103 21.1073 9.39537 21.4089C8.9908 21.4394 8.78851 21.4546 8.64973 21.4237C8.51096 21.3927 8.37123 21.3139 8.0918 21.1559C7.28512 20.7004 6.46026 20.2678 5.66929 19.7853C4.56732 19.1131 3.87763 17.9315 3.83427 16.6414C3.80961 15.9072 4.23187 15.1776 5.08486 15.3783L17.3912 18.2743C18.3156 18.4919 18.7778 18.6007 19.175 18.5266C19.5722 18.4526 20.059 18.1196 21.0328 17.4536C23.5021 15.7651 27.4153 14.1702 31.3163 15.5793C32.3841 15.965 32.9181 16.1579 33.2223 16.1675C33.5264 16.1771 33.9723 16.0474 34.8639 15.7879C36.3075 15.3677 37.6665 15.1497 38.7833 15.0835ZM38.7833 15.0835C37.2438 13.21 35.0743 11.2788 32.0727 9.5835'
      stroke='white'
      strokeOpacity='0.04'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <path
      fill='none'
      d='M38.7833 15.0835C41.2395 18.0724 42.0928 20.9143 42.1654 22.4169C40.8813 21.8297 39.4394 21.5002 37.9156 21.5002C33.229 21.5002 29.0219 24.6165 28.0172 28.7678C27.777 29.7602 27.657 30.2565 27.3962 30.4616C27.1355 30.6668 26.7148 30.6668 25.8738 30.6668H20.3561C19.5085 30.6668 19.0848 30.6668 18.823 30.4589C18.5612 30.2507 18.4465 29.7562 18.2172 28.767C17.267 24.6692 13.4103 21.1073 9.39537 21.4089C8.9908 21.4394 8.78851 21.4546 8.64973 21.4237C8.51096 21.3927 8.37123 21.3139 8.0918 21.1559C7.28512 20.7004 6.46026 20.2678 5.66929 19.7853C4.56732 19.1131 3.87763 17.9315 3.83427 16.6414C3.80961 15.9072 4.23187 15.1776 5.08486 15.3783L17.3912 18.2743C18.3156 18.4919 18.7778 18.6007 19.175 18.5266C19.5722 18.4526 20.059 18.1196 21.0328 17.4536C23.5021 15.7651 27.4153 14.1702 31.3163 15.5793C32.3841 15.965 32.9181 16.1579 33.2223 16.1675C33.5264 16.1771 33.9723 16.0474 34.8639 15.7879C36.3075 15.3677 37.6665 15.1497 38.7833 15.0835ZM38.7833 15.0835C37.2438 13.21 35.0743 11.2788 32.0727 9.5835'
      stroke='url(#paint5_radial_5307_2546)'
      strokeOpacity='0.6'
      strokeWidth='2.875'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
    <defs>
      <linearGradient
        id='paint0_linear_5307_2546'
        x1='32.5833'
        y1='26.8335'
        x2='43.5385'
        y2='34.4413'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint1_radial_5307_2546'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(37.3749 36.4168) scale(4.79167 4.88019)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint2_linear_5307_2546'
        x1='3.83325'
        y1='26.8335'
        x2='14.7885'
        y2='34.4413'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint3_radial_5307_2546'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(8.62492 36.4168) scale(4.79167 4.88019)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
      <linearGradient
        id='paint4_linear_5307_2546'
        x1='3.83325'
        y1='9.5835'
        x2='28.8712'
        y2='41.1962'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#E90083' />
        <stop offset='1' stopColor='#FF6864' />
      </linearGradient>
      <radialGradient
        id='paint5_radial_5307_2546'
        cx='0'
        cy='0'
        r='1'
        gradientUnits='userSpaceOnUse'
        gradientTransform='translate(22.9993 30.6668) scale(19.1661 10.7364)'
      >
        <stop stopColor='white' />
        <stop offset='1' stopColor='#754660' stopOpacity='0' />
      </radialGradient>
    </defs>
  </svg>,
  'MotorbikesIcon'
)

export default MotorbikesIcon
